import * as React from 'react';

import TabsUnderlined from 'components/tabs/tabs-underlined/TabsUnderlined';

import { __t, applyTranslations } from 'utils/language';

import type { SyntheticEvent } from 'react';

applyTranslations(require('./subcampaign-offer.i18n.json'));

type Props = {
  toggleExpanded: (type: boolean) => void,
  expandedIdsMap: {
    [x: string]: boolean
  }
};

class SubcampaignResizeControl extends React.PureComponent<Props> {
  handleResize = (event: SyntheticEvent<HTMLElement>): void => {
    const { toggleExpanded } = this.props;
    const target = event.currentTarget;
    const type = target.dataset.arg;

    toggleExpanded(type === 'true');
  };

  render() {
    const { expandedIdsMap } = this.props;

    const expandedTabItems = ['expand_all', 'collapse_all'].map(type => ({
      handleClick: this.handleResize,
      handleClickArg: type === 'expand_all',
      label: __t(`subcampaign_offer_module.deliverables_filters.label_${type}`)
    }));

    return (
      <div className="subcampaign-offer__filter">
        <TabsUnderlined
          items={expandedTabItems}
          size="normal"
          toggleIdsMap={expandedIdsMap}
        />
      </div>
    );
  }
}

export default SubcampaignResizeControl;
